import React, { useState } from "react";
import "../../page_content.css";
import Accordion from "../../../components/reuseable_comp/accordion/Accordion";
import MedicalFitness from "./MedicalFitness";

const CourseEligibilty = () => {
  // main accordion
  const [activeIndex, setActiveIndex] = useState(null);

  const handleToggle = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div>
      <h1 className="title">Course Wise Eligibility</h1>
      <hr />
      <h4 className="innerpage-subheading">Note:</h4>
      <ul className="page-content-lists">
        <li>Candidates must have a valid passport at the time of admission.</li>
        <li>
          Qualifying IMU CET/State level Engineering Entrance Exam/JEE (with
          more than 40 Percentile) is mandatory for First Year B. Tech Marine
          Engineering, B.Sc. Nautical Science admission
        </li>
        <li>
          Qualifying IMU CET is mandotary for Diploma in Nautical Science.
        </li>
        <li>
          Part time or distance learning or correspondence course or any
          combination of these shall not be considered.
        </li>
      </ul>

      {/* accordion 1 */}
      <Accordion
        title="B. Tech. Marine Engineering"
        isActive={activeIndex === 0}
        onClick={() => handleToggle(0)}
      />
      {activeIndex === 0 && (
        <div className="accordion-content">
          <h4 className="innerpage-subheading">Academic Qualifications</h4>
          <p>
            The candidate must have successfully completed the Senior Secondary
            Examination (10+2) or its equivalent with:
          </p>
          <ul className="page-content-lists">
            <li>
              At least 60% marks in Physics, Chemistry, and Mathematics (PCM)
            </li>
            <li>
              At least 50% marks in English either in Class X or Class XII.
            </li>
          </ul>
          <p>
            Candidates are less than 25 years of age as on 1st of August in the
            year of admission will be eligible to apply. The date of birth as
            recorded on the applicants’ School Leaving Certificate will be
            considered for this purpose.
          </p>

          <ul className="page-content-lists">
            <li>
              The maximum age limit for candidates belonging to "Scheduled
              Cast"(SC) / "Scheduled Tribe" (ST) Category shall be relaxed by 5
              years.
            </li>
            <li>
              The maximum age limit for candidates belonging to No-Creamy layer
              of "Other Backward Classes" (OBC) Category shall be relaxed by 3
              Years
            </li>
            <li>
              The maximum age limit for women candidates of each category shall
              be relaxed by additional 2 years.
            </li>
          </ul>

          <p>
            MANET encourages the participation of both sexes without
            discrimination.
          </p>

          <h4 className="innerpage-subheading">Marital Status</h4>
          <p>Only Unmarried candidates will be considered.</p>

          <h4 className="innerpage-subheading">Physical Fitness</h4>
          <p>
            The Institute has laid down detailed minimum physical fitness and
            medical standards. The candidate must meet the standards to qualify
            for admission. You are advised to have yourself medically examined
            by competent doctors before applying. This will ensure that you meet
            the minimum requirements, which in turn will avoid disappointment at
            a later stage.
          </p>

          <MedicalFitness />
        </div>
      )}

      {/* accordion 2 */}
      <Accordion
        title="B. Sc. Nautical Science"
        isActive={activeIndex === 1}
        onClick={() => handleToggle(1)}
      />
      {activeIndex === 1 && (
        <div className="accordion-content">
          <h4 className="innerpage-subheading">Academic Qualifications</h4>
          <p>
            The candidate must have successfully completed the Senior Secondary
            Examination (10+2) or its equivalent with:
          </p>
          <ul className="page-content-lists">
            <li>
              At least 60% marks in Physics, Chemistry and Mathematics (PCM)
            </li>
            <li>
              At least 50% marks in English either in Class X or Class XII.
            </li>
          </ul>
          <p>
            Candidates are less than 25 years of age as on 1st of August in the
            year of admission will be eligible to apply. The date of birth as
            recorded on the applicants’ School Leaving Certificate will be
            considered for this purpose.
          </p>
          <ul className="page-content-lists">
            <li>
              The maximum age limit for candidates belonging to "Scheduled Cast"
              (SC) / "Scheduled Tribe" (ST) Category shall be relaxed by 5
              years.
            </li>
            <li>
              The maximum age limit for candidates belonging to No-Creamy layer
              of "Other Backward Classes" (OBC) Category shall be relaxed by 3
              Years
            </li>
            <li>
              The maximum age limit for women candidates of each category shall
              be relaxed by additional 2 years.
            </li>
          </ul>
          <p>
            MANET encourages the participation of both sexes without
            discrimination.
          </p>
          <h4 className="innerpage-subheading">Marital Status</h4>
          <p>Only Unmarried candidates will be considered.</p>

          <MedicalFitness />
        </div>
      )}

      {/* accordion 3 */}
      <Accordion
        title="Diploma In Nautical Science"
        isActive={activeIndex === 2}
        onClick={() => handleToggle(2)}
      />
      {activeIndex === 2 && (
        <div className="accordion-content">
          <h4 className="innerpage-subheading">Academic Qualifications</h4>
          <p>
            The candidate must have successfully completed the Senior Secondary
            Examination (10+2) or its equivalent with:
          </p>
          <ul className="page-content-lists">
            <li>
              At least 60% marks in Physics, Chemistry and Mathematics (PCM)
            </li>
            <li>
              At least 50% marks in English either in Class X or Class XII
            </li>
          </ul>
          <div className="page-content-note">
            <b>Note : </b>
            Sponsorship from shipping companies is mandatory to secure admission
            to the DNS program.
          </div>
          <p>
            Candidates are less than 25 years of age as on 1st of August in the
            year of admission will be eligible to apply. The date of birth as
            recorded on the applicants’ School Leaving Certificate will be
            considered for this purpose.
          </p>
          <ul className="page-content-lists">
            <li>
              The maximum age limit for candidates belonging to "Scheduled Cast"
              (SC) / "Scheduled Tribe" (ST) Category shall be relaxed by 5
              years.
            </li>
            <li>
              The maximum age limit for candidates belonging to No-Creamy layer
              of "Other Backward Classes" (OBC) Category shall be relaxed by 3
              Years
            </li>
            <li>
              The maximum age limit for women candidates of each category shall
              be relaxed by additional 2 years.
            </li>
          </ul>
          <h4 className="innerpage-subheading">Physical Standards</h4>
          <p>
            The Institute has laid down detailed minimum physical fitness and
            medical standards. To be declared fit for selection, a candidate
            must be in good mental and physical health and free from any
            deficiency likely to interfere with the efficient performance of
            duties, as per the medical standards laid down by the Directorate
            General of Shipping, Govt. of India.
          </p>
          <p>
            Candidates for DNS (IMU) program must have 6/6 vision in both eyes
            or 6/6 in one eye and 6/9 in the other eye. Color blindness is not
            permitted.
          </p>
          <div className="page-content-note">
            <p>
              Medical fitness must be certified by DG Shipping-approved company
              doctors.
            </p>
          </div>
        </div>
      )}

      {/* accordion 4 */}
      <Accordion
        title="Electro Technical Officer (ETO)"
        isActive={activeIndex === 3}
        onClick={() => handleToggle(3)}
      />
      {activeIndex === 3 && (
        <div className="accordion-content">
          <h4 className="innerpage-subheading">Academic Qualifications</h4>
          <h4 className="innerpage-subheading">1. English Proficiency:</h4>
          <p>
            A minimum of 50% marks in English at either the 10th or 12th
            standard, or a diploma or degree level is required.
          </p>
          <h4 className="innerpage-subheading">2. Degree in Engineering:</h4>

          <ul className="page-content-lists">
            <li>
              A four-year degree (including lateral entry) with 50% marks in
              Electrical Engineering, Electronics Engineering, Electrical &
              Electronics Engineering, Electronics &
              Telecommunication/Communication Engineering, or Electronics and
              Instrumentation Engineering is required.
            </li>
            <li>
              If English marks are less than 50% at 10th or 12th, but the
              diploma/degree was taught in English and other criteria are met,
              eligibility may be considered.
            </li>
          </ul>
          <p>
            Candidates are less than 25 years of age as on 1st of August in the
            year of admission will be eligible to apply. The date of birth as
            recorded on the applicants’ School Leaving Certificate will be
            considered for this purpose.
          </p>
          <ul className="page-content-lists">
            <li>
              The maximum age limit for candidates belonging to "Scheduled Cast"
              (SC) / "Scheduled Tribe" (ST) Category shall be relaxed by 5
              years.
            </li>
            <li>
              The maximum age limit for candidates belonging to No-Creamy layer
              of "Other Backward Classes" (OBC) Category shall be relaxed by 3
              Years
            </li>
            <li>
              The maximum age limit for women candidates of each category shall
              be relaxed by additional 2 years.
            </li>
          </ul>
          <div className="page-content-note">
            <p>
              Medical fitness must be certified by DG Shipping-approved company
              doctors.
            </p>
          </div>
        </div>
      )}

      {/* accordion 5 */}
      <Accordion
        title="B. Tech. Marine Engineering (Lateral Entry)"
        isActive={activeIndex === 4}
        onClick={() => handleToggle(4)}
      />
      {activeIndex === 4 && (
        <div className="accordion-content">
          <h4 className="innerpage-subheading">Academic Qualifications</h4>
          <ul className="page-content-lists">
            <li>
              The candidates can laterally join the 2nd year of the 4 year
              Marine Engineering degree course who have passed 3 years Diploma
              course in the following streams, in addition to the 3 year regular
              Diploma course in Mechanical/Electrical/Electrical and Electronics
              Engineering from the colleges as approved by the AICTE or the
              State Board of Technical Education with minimum 55% aggregate
              marks in the last year of the Diploma course.
            </li>
            <li>
              The candidate should have obtained minimum 50% of marks in the
              English language in 10th OR 12th standard OR in the Degree/Diploma
              course conducted by recognized board OR any University.
            </li>
          </ul>
          <p>
            Candidates are less than 25 years of age as on 1st of August in the
            year of admission will be eligible to apply. The date of birth as
            recorded on the applicants’ School Leaving Certificate will be
            considered for this purpose.
          </p>
          <ul className="page-content-lists">
            <li>
              The maximum age limit for candidates belonging to "Scheduled Cast"
              (SC) / "Scheduled Tribe" (ST) Category shall be relaxed by 5 years
            </li>
            <li>
              The maximum age limit for candidates belonging to No-Creamy layer
              of "Other Backward Classes" (OBC) Category shall be relaxed by 3
              Years
            </li>
            <li>
              The maximum age limit for women candidates of each category shall
              be relaxed by additional 2 years.
            </li>
          </ul>
          <h4 className="innerpage-subheading">
            1. Mechanical Engineering Stream
          </h4>
          <p>
            3 Years Diploma in (a) Auto-mobile Engineering (b) Machine Tools and
            Maintenance/ Plant Engineering (c) Production Technology (d)
            Production Engineering (e) Advance Diploma in Tool and Die-making
          </p>
          <h4 className="innerpage-subheading">
            2. Electrical Engineering Streams
          </h4>
          <p>3 Years’ Diploma in Electrical Power System</p>
          <h4 className="innerpage-subheading">
            3. Electrical and Electronics Engineering Streams
          </h4>
          <p>
            3 Years Diploma in (a) Digital Electronics (b) Electronics and
            Communications Engineering (c) Electronics and Tele-Communications
            Engineering (d) Industrial Electronics (e) Electronics Engineering
            (f) Electronics Production and Maintenance (g) Electronics (h)
            Instrumentation (i) Instrumentation and Control
          </p>
        </div>
      )}
    </div>
  );
};

export default CourseEligibilty;
